import {
    FILTER_REQUESTS_DATA,
    REQUESTS_DATA,
    EDIT_Request,
    EDIT_Payment,
    REQUESTS_COUNT,

} from "../../constants/Tabs-Action-Types";
import utils from "../../../utils/utils";
import {authenticationService} from "../../../services/AuthenticationService";
import React from "react";


const initialState = {
    initiateRequestsData:[],
    requestsData:[],
    filterRequestsData:[],
    requestsTableFilter:{},
};


function getInsurace(insuranceID){
    let currentUser = authenticationService.currentUserValue;
    let language = localStorage.getItem('language')

    switch (insuranceID) {
        case "1": return language==="he" ? "מכבי" : "Maccabi"
        case "2": return  language==="he" ? "כללית":"Clalit"
        case "3": return  language==="he" ? "לאומית":"Leumit"
        case "4": return  language==="he" ? "מאוחדת":"Meuhedet"
        case "5": return  language==="he" ? "חברת ביטוח":"Insurance company"
        case "6": return  language==="he" ? "צה\"ל":"IDF"
        case "7": return  language==="he" ? "משרד הביטחון":"Ministry of Defence"
        case "8": return  language==="he" ? "ללא ביטוח":"No Insurance"
        case "9": return  language==="he" ? "רשות פלסטינאית":"The Palestinian Authority"
        case "10": return language==="he" ? "אחר":"Other"
        default:return ""
    }
}
const patientRequestsTableDataReducer = (state = initialState, action)=> {

    switch(action.type){
        case REQUESTS_COUNT:{
            let _idata = JSON.parse(JSON.stringify(action.payload));
            state = {
                ...state,
                requestsCount: _idata
            };
            break;
        }
        case EDIT_Payment: {
            let patient = action.payload
            let patientData = state.requestsData
            let initiatePatientData = state.initiateRequestsData

            let indexData = patientData.findIndex((obj => obj.UserStorageID === patient.UserStorageID && obj.RequestID===patient.RequestID));
            let indexInit = initiatePatientData.findIndex((obj => obj.UserStorageID === patient.UserStorageID && obj.RequestID===patient.RequestID));

            patientData[indexData]['PayedSum'] = patient.PayedSum
            patientData[indexData]['requestDate'] = patient.paymentDate?patient.paymentDate.toISOString():''
            patientData[indexData]['paymentDate'] = patient.paymentDate?patient.paymentDate.toISOString():''
            patientData[indexData]['isPaid'] = patient.paymentDate?'Y':'N'

            initiatePatientData[indexInit]['PayedSum'] = patient.PayedSum
            initiatePatientData[indexInit]['requestDate'] = patient.paymentDate?patient.paymentDate.toISOString():''
            initiatePatientData[indexInit]['paymentDate'] = patient.paymentDate?patient.paymentDate.toISOString():''
            initiatePatientData[indexInit]['isPaid'] = patient.paymentDate?'Y':'N'

            let _pdata = JSON.parse(JSON.stringify(patientData));
            let _idata = JSON.parse(JSON.stringify(initiatePatientData));
            state = {
                ...state,
                initiateRequestsData: _idata,
                requestsData: _pdata,
            };
            break;
        }
        case EDIT_Request: {
            let patient = action.payload
            let patientData = state.requestsData
            let initiatePatientData = state.initiateRequestsData

            let indexData = patientData.findIndex((obj => obj.UserStorageID === patient.UserStorageID && obj.RequestID===patient.RequestID));
            let indexInit = initiatePatientData.findIndex((obj => obj.UserStorageID === patient.UserStorageID && obj.RequestID===patient.RequestID));

            patientData[indexData]['RequestInfo'] = patient.RequestInfo
            patientData[indexData]['HasInfo'] = patient.RequestInfo && patient.RequestInfo.length>0?"Y":"N"

            initiatePatientData[indexInit]['RequestInfo'] = patient.RequestInfo
            initiatePatientData[indexInit]['HasInfo'] = patient.RequestInfo && patient.RequestInfo.length>0?"Y":"N"


            let _pdata = JSON.parse(JSON.stringify(patientData));
            let _idata = JSON.parse(JSON.stringify(initiatePatientData));
            state = {
                ...state,
                initiateRequestsData: _idata,
                requestsData: _pdata,
            };
            break;
        }

        case REQUESTS_DATA: {
            let collection = []
            let statuses = action.statuses
            let currentUser = authenticationService.currentUserValue;
            let language = localStorage.getItem('language')
            let status=""
            action.payload.forEach(patient => {

                let insurance= patient &&patient.Patient && patient.Patient.PII? getInsurace(patient.Patient.PII.Insuring_factor):""
                let statusIndex = statuses.findIndex((element)=> element.status_ID===patient.requestStatus);
                if(statusIndex){
                    status= language==="he" ?statuses[statusIndex]?.status_desc_he:statuses[statusIndex]?.status_desc
                }

      /*              for(let i=0;i<statuses.length;i++){
                    if(statuses[i].status_ID===patient.requestStatus && language==="he"){
                        status= statuses[i].status_desc_he
                    }else if(statuses[i].status_ID===patient.requestStatus && language==="en"){
                        status= statuses[i].status_desc
                    }
                }*/
                let programm = patient.choose_programm
                if(language==="he"){
                    programm = programm === "new" ? "הוצאת רישיון חדש" : programm
                    programm = programm === "renew" ? "חידוש רישיון למטופלים קיימים" : programm
                    programm = programm === "renew2" ? "חידוש רישיון למטופלים חדשים" : programm
                    programm = programm === "new" ? "הוצאת רישיון חדש" : programm
                    programm = programm === "renew" ? "חידוש רישיון למטופלים קיימים" : programm
                    programm = programm === "renew2" ? "חידוש רישיון למטופלים חדשים" : programm
/*
                    programm = programm === "change" ? "חידוש רישיון מעל שנה (ביקור II)" : programm
*/
                }

                let patientPII= patient && patient.Patient && patient.Patient.PII?patient.Patient.PII:{}
                let date= patient.PatientsPayment ?new Date(patient.PatientsPayment.paymentDate): ''

                collection.push(
                    {
                        Payment_ID:patient.PatientsPayment?patient.PatientsPayment.Payment_ID:null,
                        UserStorageID:patient.UserStorageID ,
                        RequestID:patient.RequestID ,
                        ShowFlag:patient && patient.Patient && patient.Patient.ShowFlag,
                        renewCurrentDose:patient.renewCurrentDose==="Yes"?"Y":"N"  ,
                        PatientName:patientPII.First_name + " " +patientPII.Last_name ,
                        isPaid:patient.PatientsPayment ?"Y":"N" ,
                        hasOldRequest: patient.hasOldRequest ,
                        PayedSum:patient.PatientsPayment ?patient.PatientsPayment.Sum:0 ,
                        paymentDate: date ,
                        HasInfo:patient.RequestInfo && patient.RequestInfo.length>0?"Y":"N" ,
                        RequestInfo:patient.RequestInfo,
                        resourceName:patientPII?.RequestSource?.RequestSource_Name,
                        PatientID:patientPII.ID_passport,
                        Phone_num1:patientPII.Phone_num1.replace("972","0"),
                        insurance:insurance,
                        choose_programm: programm,
                        // requestDate: patient.PII?.Gender?patient.PII?.Gender.substring(0,1):"",
                        requestDate:patient.requestDate,
                        requestStatus: status,
                    }
                )
            })

            let _pdata = JSON.parse(JSON.stringify(collection));
            state = {
                ...state,
                initiateRequestsData: _pdata,
                requestsData: _pdata,
            };
            break;
        }
        case FILTER_REQUESTS_DATA: {
            let type = action.searchType
            let payload = action.payload
            let requestsTableFilter = state.requestsTableFilter
            let filteredRequestsData = state.initiateRequestsData
            let visibleFilterData = []
            let visiableData = []
            if (type === 'status' && payload === 'total'){
                delete requestsTableFilter.status
            } else {
                utils.set(requestsTableFilter,type,payload)
            }

            if (type === 'clear' && (payload === '' || payload === null)){
                requestsTableFilter={}
            }
            if (type === 'search' && (payload === '' || payload === null)){
                delete requestsTableFilter.search
            } else {
                utils.set(requestsTableFilter,type,payload)
            }
            if (type === 'localSaveFilterRequests') {
                requestsTableFilter = payload
                delete requestsTableFilter.search
            }


            for (const [key, value] of Object.entries(requestsTableFilter)) {
                if (key === 'search'){
                    let val = value.toLowerCase()
                    filteredRequestsData = filteredRequestsData.filter(x =>
                        String(x.PatientName).toLowerCase().indexOf(val) > -1 ||
                        String(x.PatientID).toLowerCase().indexOf(val) > -1||
                        String(x.choose_programm).toLowerCase().indexOf(val) > -1||
                        String(x.requestStatus).toLowerCase().indexOf(val) > -1 ||
                        String(x.Phone_num1).toLowerCase().indexOf(val) > -1 ||
                        String(x.insurance).toLowerCase().indexOf(val) > -1
                    )
                    visibleFilterData = filteredRequestsData
                }else{
                    let patients = JSON.parse(JSON.stringify(filteredRequestsData))
                    let valArr = JSON.parse(JSON.stringify(value))
                    if (Array.isArray(valArr)){
                        let res = []
                        valArr.forEach(val => {
                            let hcpArr = patients.filter(hcp => {
                                let hcpVal = hcp[key]
                                return String(hcpVal).toLowerCase() === String(val).toLowerCase()
                            })
                            hcpArr.forEach(hcp => res.push(hcp))
                        })
                        filteredRequestsData = res
                    }
                }
            }

            localStorage.setItem("filterRequests", JSON.stringify(requestsTableFilter))
            visiableData = filteredRequestsData
            let _fpdata = JSON.parse(JSON.stringify(visibleFilterData));
            let _vdata = JSON.parse(JSON.stringify(visiableData));
            let _pfdata = JSON.parse(JSON.stringify(requestsTableFilter));

            state = {
                ...state,
                filteredRequestsData: _fpdata,
                requestsData: _vdata,
                requestsTableFilter: _pfdata
            };
            break;
        }


        default:
            break;
    }
    return state;
};

export default patientRequestsTableDataReducer;
